import React         from 'react';
import { Container } from './styles';
import '../mobile.styles.scss';

export function Toolbar() {
    return <Container id="toolbar-wrapper" />;
}
